import styled from "styled-components"
import { images } from "../../../content-options/lineUp"
import { Dispatch, FC, SetStateAction } from "react"
import { LineupPosition } from "../../../models/team"
import { useUser } from "../../../context/useUser"
import playerImage from "../../../images/lineup/shirt.png"
import { useLeague } from "../../../context/useLeague"

interface Props {
  lineupPositions: LineupPosition[]
  playerClickedRemovesThem?: boolean
}

const Pitch: FC<Props> = ({ lineupPositions, playerClickedRemovesThem }) => {
  const { user } = useUser()
  const { lineup, userTeam, setLineup } = useLeague()

  // data
  const coords = {
    Gk: ["44%", "7%"], // gk
    Rb: ["77%", "29%"], // def
    Rcb: ["60%", "25%"],
    Ccb: ["44%", "22%"],
    Lcb: ["28%", "25%"],
    Lb: ["12%", "29%"],
    Lm: ["14%", "56%"], // mid
    Lcm: ["30%", "55%"],
    Cm: ["44%", "50%"],
    Rcm: ["58%", "55%"],
    Ldm: ["26%", "44%"],
    Rdm: ["62%", "44%"],
    Rm: ["75%", "56%"],
    Cdm: ["44%", "35%"],
    Cam: ["44%", "62%"],
    Lam: ["20%", "62%"],
    Ram: ["68%", "62%"],
    Ls: ["32%", "78%"], // attack
    Cf: ["44%", "70%"],
    Lf: ["26%", "70%"],
    Rf: ["62%", "70%"],
    St: ["44%", "85%"],
    Rs: ["56%", "78%"],
    Lw: ["17%", "75%"],
    Rw: ["71%", "75%"],
    Any: ["-2%", "6%"],
  }

  // methods
  const handleClickPlayer = (position: LineupPosition) => {
    if (playerClickedRemovesThem) {
      // check user is the manager
      const isManager = userTeam?.managerId._id === user?._id
      if (!isManager) {
        return
      }
      // remove player from lineup
      const newLineup = lineup.filter((lineupPosition) => lineupPosition.position !== position.position)
      setLineup(newLineup)
    }
  }

  return (
    <>
      <Wrapper>
        <Container pitch={images.pitch}>
          {lineupPositions.map((lineupPosition, i) => (
            <>
              {user ? (
                <div key={lineupPosition.user._id}>
                  <PlayerContainer
                    position={lineupPosition.position}
                    coords={coords}
                    onClick={() => handleClickPlayer(lineupPosition)}
                  >
                    <Image image={lineupPosition.user.profileImage || playerImage}></Image>
                    <NameContainer>
                      <p>{lineupPosition.isAny ? "Any" : lineupPosition.user.username}</p>
                    </NameContainer>
                  </PlayerContainer>
                </div>
              ) : null}
            </>
          ))}
        </Container>
      </Wrapper>
    </>
  )
}

export default Pitch

// Pitch

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`
const Container = styled.div<ContainerProps>`
  background-image: url(${(props) => props.pitch});
  background-size: cover;
  position: relative;
  border-radius: 8px;
  width: 100%;
  aspect-ratio: 370/540;
  border: 0.5px solid gray;
  box-shadow: 0px 1px 5px rgb(38, 38, 38);
`
interface ContainerProps {
  pitch: string
}

// player

interface PlayerContainerProps {
  image?: string
  position: string
  coords: { [key: string]: string[] } // Adjusted based on your `coords` object
  setPlayerClicked?: Dispatch<SetStateAction<boolean>>
}

const PlayerContainer = styled.div<PlayerContainerProps>`
  height: 50px;
  position: absolute;
  left: ${(props) => props?.coords[props.position] && props?.coords[props?.position][0]};
  bottom: ${(props) => props?.coords[props?.position] && props?.coords[props?.position][1]};
  background-size: cover;
  @media (max-width: 480px) {
    width: 45px;
    height: 45px;
  }
  cursor: ${(props) => (props?.setPlayerClicked ? "pointer" : null)};
`

interface ImageProps {
  image: string
}

const Image = styled.div<ImageProps>`
  width: 50px;
  height: 50px;
  background-image: url(${(props) => props.image});
  background-size: cover;
  @media (max-width: 480px) {
    width: 45px;
    height: 45px;
  }
`
const NameContainer = styled.div`
  text-align: center;
  font-size: 12px;
  @media (max-width: 480px) {
    font-size: 12px;
  }
`
